import { useEffect, useState } from 'react';
import { listBoardTrips, type BoardTrip } from '../dispatch.api';

const PAGE_SIZE = 10;

export type BoardTripsState = { status: 'loading' } | { status: 'loaded'; trips: BoardTrip[]; total: number; isLoadingMore: boolean } | { status: 'error' };

/** The trips panel is a "load more" feed, so its page number is local state rather than part of the URL (gitaumoses4/chukua#55). */
export function useBoardTrips() {
  const [state, setState] = useState<BoardTripsState>({ status: 'loading' });
  const [pageToLoad, setPageToLoad] = useState(1);
  const [reloads, setReloads] = useState(0);

  useEffect(() => {
    let cancelled = false;
    listBoardTrips({ page: pageToLoad, pageSize: PAGE_SIZE })
      .then((page) => {
        if (cancelled) return;
        setState((current) => ({
          status: 'loaded',
          trips: current.status === 'loaded' && pageToLoad > 1 ? [...current.trips, ...page.items] : page.items,
          total: page.total,
          isLoadingMore: false,
        }));
      })
      .catch(() => {
        if (!cancelled) setState({ status: 'error' });
      });
    return () => {
      cancelled = true;
    };
  }, [pageToLoad, reloads]);

  function loadMore(): void {
    setState((current) => (current.status === 'loaded' ? { ...current, isLoadingMore: true } : current));
    setPageToLoad((page) => page + 1);
  }

  function reload(): void {
    setState({ status: 'loading' });
    setPageToLoad(1);
    setReloads((count) => count + 1);
  }

  return { state, loadMore, reload };
}
